export const checkEmail = (email: string) => /^[^@]+@[^@]+\.[^@]+$/m.test(email)

export const isNumeric = (value: string): boolean => /^\d+$/.test(value)
